import { NavLink } from "react-router-dom";
import { Container } from "../../../utils/CustomComponents";

function WhatWeDo() {
    return (
        <div id="what_we_do">
            <Container>
                <h1 className="header">what we do</h1>
                <p>
                    Dgreat Allot Pensions Solves the recurring pension problems in Africa and other
                    Developing Nations with the use of Blockchain Technology, decentralizing the
                    Pensions System and avoiding the instability of Fiat Currencies with Crypto
                    Tokens.
                </p>
                <p>
                    With Dgreat Allot Pensions you have a secured pension system, that is
                    decentralized and totally secured.
                </p>
                <p>
                    Also, with the help of Cryptocurrency and Blockchain technology pensioners get
                    to stake their pensions in a particular cryptocurrency to earn more while
                    waiting for retirement. Self-employed individuals can also be pensionable with
                    our system.
                </p>
                <NavLink to="/about">
                    <button className="btn_pry">Read more</button>
                </NavLink>
            </Container>
        </div>
    );
}

export default WhatWeDo;
